// Warna & label "kekuatan dukungan" dipakai bareng oleh Peta Sebaran
// (halaman penuh) dan peta mini di Dashboard, supaya keduanya konsisten.
export const STRENGTH_LEVELS = [
  { min: 80, c: '#EA580C', l: 'Sangat Kuat' },
  { min: 60, c: '#F97316', l: 'Kuat' },
  { min: 40, c: '#FB923C', l: 'Sedang' },
  { min: 20, c: '#FDBA74', l: 'Lemah' },
  { min: 0, c: '#DC2626', l: 'Sangat Lemah' },
];
export const NO_DATA_COLOR = '#9CA3AF';
export const NO_DATA_LABEL = 'Belum Ada Data';

// hasData=false (mis. kecamatan belum punya Target Suara) dipetakan ke warna
// abu-abu netral, bukan "Sangat Lemah" - supaya "belum dinilai" tidak
// tercampur dengan "sudah dinilai tapi hasilnya lemah".
export const strengthColor = (pct, hasData = true) => {
  if (!hasData) return NO_DATA_COLOR;
  return (STRENGTH_LEVELS.find(lvl => pct >= lvl.min) || STRENGTH_LEVELS[STRENGTH_LEVELS.length - 1]).c;
};

export const strengthLabel = (pct, hasData = true) => {
  if (!hasData) return NO_DATA_LABEL;
  return (STRENGTH_LEVELS.find(lvl => pct >= lvl.min) || STRENGTH_LEVELS[STRENGTH_LEVELS.length - 1]).l;
};
